export const abortController = (timeout = 2500) => {
  const controller = typeof AbortController === 'function' ? new AbortController() : undefined

  const timer = setTimeout(() => {
    controller?.abort()
  }, timeout)

  return { timer, controller }
}